export default {
    VUE_APP_URL_PRODUCAO_BACKEND: 'https://adminlabsaude.undb.edu.br',
    VUE_APP_URL_HOMOLOG_BACKEND: 'http://localhost:8002',
}